import React from 'react';
import './Modal.css';
import Button from '../Button/Button';

const Modal = ({
  isOpen,
  onClose,
  error = false,
  title,
  message,
  confirmText = 'Confirm',
  showConfirmButton = true,
  onConfirm,
  cancelText = 'Cancel',
  showCancelButton = true,
  onCancel,
  rejectText = 'Reject',
  showRejectButton = false,
  onReject,
  ariaLabel = 'Modal dialog',
  padding = '2rem',
}) => {
  if (!isOpen) return null;

  // --- Normaliza el título para soportar todos los formatos ---
  let pre = '', highlight = '', post = '';
  if (typeof title === 'string') {
    pre = title;
  } else if (title && typeof title === 'object') {
    const { text, pre: tPre, post: tPost, highlight: tHighlight } = title;
    pre = tPre ?? text ?? '';
    highlight = tHighlight ?? '';
    post = tPost ?? '';
  }

  const handleCancel = () => (onCancel ? onCancel() : onClose?.());

  const footerButtonsCount = [showCancelButton, showRejectButton, showConfirmButton].filter(Boolean).length;

  return (
    <div className="modal-overlay" role="dialog" aria-label={ariaLabel} aria-modal="true">
      <div className="modal-content" style={{ padding }}>
        <div className="modal-header">
          <h2 className="modal-title">
            <span className="title-text">
              {pre}
              {highlight ? (
                <>
                  {' '}
                  <span className={error ? 'error' : 'highlight-modal'}>{highlight}</span>
                  {post ? ' ' : ''}
                </>
              ) : null}
              {post}
            </span>
          </h2>
        </div>

        {message && (
          <div className="modal-body">
            <p>{message}</p>
          </div>
        )}

        <div className={`modal-footer ${footerButtonsCount === 1 ? 'single' : ''}`}>
          {showCancelButton && (
            <Button type="button" variant="error" onClick={handleCancel} fullWidth className="pill-btn shadow-btn">
              {cancelText}
            </Button>
          )}

          {showRejectButton && (
            <Button type="button" variant="secondary" onClick={onReject} fullWidth className="pill-btn shadow-btn">
              {rejectText}
            </Button>
          )}

          {showConfirmButton && (
            <Button 
              onClick={onConfirm}
              type="button"
              fullWidth
              variant={error ? 'error' : 'primary'}
            >
              {confirmText}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;